module.exports = "<div class=\"dms-usergridconfig\">\r\n</div>";